import { render, staticRenderFns } from "./SkillSelect.vue?vue&type=template&id=01d52dbe"
import script from "./SkillSelect.vue?vue&type=script&lang=js"
export * from "./SkillSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports